import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page34() {
  useEffect(() => {
    document.title = "Маяк — Страница 33"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page32" />
        <ForwardLink href="/page34" />
      </div>

      <p style={{ textAlign: "right" }}>33.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Нет...
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        ...как любой человек, пытающийся<br/>
        тихо устроиться с некоторыми<br/>
        сбережениями...
      </p>
      <p style={{ textAlign: "center" }}>
        Я читал, что человек может заработать шестьсот <br/>
        тридцать -- Я читал, <i>что тысячу</i><br/>
        долларов в год, если он готов<br/>
        присматривать за маяком далеко от берега...<br/>
        чем дальше, тем больше он зарабатывает. Я<br/>
        прочитал это, и черт возьми, я сказал,<br/>
        дасэр. Работать. Делать сбережения.<br/>
        Скоро я построю собственный<br/>
        дом, где-нибудь в глуши,<br/>
        и никто не сможет мне ничего сказать...<br/>
        Вот и все.
      </p>
      <p>
        МОЛОДОЙ улыбается. Он думает, что неплохо справляется,<br/>
        скрывая свой страх, что СТАРИК может понимать больше, чем говорит.<br/>
        Сигарета помогает.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Очередная скучная история, да?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Сами спросили.
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. ГОСТИНАЯ – ПОЗЖЕ ТОЙ ЖЕ НОЧЬЮ</p>
      <p>СТАРИК сидит в качалке, вяжет и курит трубку.</p>
      <p>
        МОЛОДОЙ сидит на полу у открытой печи и греет руки.<br/>
        Он закуривает сигарету лучиной<br/>
        и закрывает дверцу.
      </p>
      <p>Затягивается.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Скажите, почему убить чайку – плохая<br/>
        примета?
      </p>
      <p>СТАРИК серьезно попыхивает трубкой.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        В них живут души моряков, которые<br/>
        встретились с Создателем.
      </p>
      <p>МОЛОДОЙ старается больше не насмехаться. СТАРИК это понимает.</p>
      <p style={{ textAlign: "right" }}>33.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page32" />
        <ForwardLink href="/page34" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710020784/the-lighthouse-script/pexkqulzr3jf5uzzk8xi.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page34;
